import { ActionType } from 'typesafe-actions'
import { FastTrackPersonDetails } from 'types/global'

import {
  FAST_TRACK_PERSON_DETAILS_REQUESTED,
  FAST_TRACK_PERSON_DETAILS_COMPLETED,
  FAST_TRACK_PERSON_DETAILS_FAILED,
} from 'actions/fastTrackReg-actions'

import * as actions from 'actions/fastTrackReg-actions'

type FastTrackRegAction = ActionType<typeof actions>

export type State = Readonly<{
  personDetails: FastTrackPersonDetails | null
  loadingPersonDetails: boolean
  error: Error | null
}>

const initialState: State = {
  personDetails: null,
  loadingPersonDetails: false,
  error: null,
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: FastTrackRegAction): State {
  switch (action.type) {
    case FAST_TRACK_PERSON_DETAILS_REQUESTED:
      return { ...state, error: null, loadingPersonDetails: true }
    case FAST_TRACK_PERSON_DETAILS_COMPLETED:
      return { personDetails: action.payload, loadingPersonDetails: false, error: null }
    case FAST_TRACK_PERSON_DETAILS_FAILED:
      return { ...state, error: action.payload, loadingPersonDetails: false }
    default:
      return state
  }
}
